/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import memoizeOne, { type MemoizedFn } from 'memoize-one';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { getSSRMark } from './ssr-mark.tsx';
import { getSSRTimings } from './timings.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getSSRFeatureFlags = memoizeOne((): any => {
	try {
		const metaTagValue = getMeta('spa-service-flags');
		if (metaTagValue === null) return null;
		return JSON.parse(metaTagValue) || null;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		return null;
	}
});

export const ssr: {
	readonly getDoneMark: () => number | null;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly getTimings: () => any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly getFeatureFlags: MemoizedFn<() => any>;
} = {
	getDoneMark: getSSRMark,
	getTimings: getSSRTimings,
	getFeatureFlags: getSSRFeatureFlags,
} as const;

export const ssrExtended: {
	readonly includeFeatureFlags: 'when-available';
	readonly getDoneMark: () => number | null;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly getTimings: () => any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly getFeatureFlags: MemoizedFn<() => any>;
} = {
	...ssr,
	includeFeatureFlags: 'when-available',
} as const;
